import { render } from "./PublicationResults.vue?vue&type=template&id=bb6eb26c&scoped=true"
import script from "./PublicationResults.vue?vue&type=script&lang=js"
export * from "./PublicationResults.vue?vue&type=script&lang=js"

import "./PublicationResults.vue?vue&type=style&index=0&id=bb6eb26c&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6eb26c"]])

export default __exports__